import {HStack, Text} from 'platform/foundation';

interface CalculatorValueProps {
  label: string;
  value: string;
}

export function CalculatorValue(props: CalculatorValueProps) {
  return (
    <HStack justify="space-between" spacing={4} align="center">
      <Text size="small" color="tertiary">
        {props.label}
      </Text>
      <Text size="small" color="white" alternative>
        {props.value}
      </Text>
    </HStack>
  );
}
